import React from 'react';
import SarasMenu from '../../../../../library/repeater/menu/SarasMenu';
import SarasMenuItem from '../../../../../library/repeater/menu/SarasMenuItem';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { Icon } from '../../../../../library/decor/SarasIcons';

const DISPLAY_MODE_OPTIONS = [
    { key: 'mini', label: 'Compact' },
    { key: 'photo', label: 'Photo Grid' }
    // { key: 'detailed', label: 'Detailed' }
];

const SNAP_MODE_OPTIONS = [
    { key: 'first_date', label: 'First Date of Week' },
    { key: 'last_date', label: 'Last Date of Week' }
    // { key: 'custom', label: 'Ask for Custom Date' }
];

const toMenuData = (options) => options.map((option) => ({ [option.key]: option.label }));

const findOptionLabel = (options, key, fallback) => {
    const matchedOption = options.find((option) => option.key === key);
    return matchedOption ? matchedOption.label : fallback;
};

const renderMenuTrigger = (label, value) => {
    const DropdownIcon = Icon['arrowmenu'];

    return (
        <span className='uiActionWithMenu uiFlexBox3 uiHover' style={{ justifyContent: 'flex-end', minWidth: '180px' }}>
            <span>
                <SarasTrans value={value} />
            </span>
            <DropdownIcon className='uiBrandColor1' />
        </span>
    );
};

const renderMenuRow = (label, trigger, contentStyle = {}) => (
    <div className='uiFlexBox' style={{ justifyContent: 'space-between', alignItems: 'center', gap: '12px', ...contentStyle }}>
        <span style={{ color: '#5e708c' }}>
            <SarasTrans value={label} />
        </span>
        {trigger}
    </div>
);

const ProdPlanGridControl = ({ viewData, calendarControl }) => {
    const serverDisplayMode = viewData?.displayMode || 'mini';
    const serverSnapMode = viewData?.snapMode || 'last_date';
    const displayModeSettingKey = '';
    const snapModeSettingKey = '';

    const activeDisplayMode = calendarControl?.getSetting
        ? calendarControl.getSetting('displayMode', serverDisplayMode)
        : serverDisplayMode;
    const activeSnapMode = calendarControl?.getSetting
        ? calendarControl.getSetting('snapMode', serverSnapMode)
        : serverSnapMode;

    const displaySelectedIndex = DISPLAY_MODE_OPTIONS.findIndex((option) => option.key === activeDisplayMode);
    const snapSelectedIndex = SNAP_MODE_OPTIONS.findIndex((option) => option.key === activeSnapMode);

    const onDisplayModeSelect = async (event, index) => {
        const selectedOption = DISPLAY_MODE_OPTIONS[Number(index)];
        if (!selectedOption || !calendarControl?.setSetting) return;

        await calendarControl.setSetting('displayMode', selectedOption.key, displayModeSettingKey);
    };

    const onSnapModeSelect = async (event, index) => {
        const selectedOption = SNAP_MODE_OPTIONS[Number(index)];
        if (!selectedOption || !calendarControl?.setSetting) return;

        await calendarControl.setSetting('snapMode', selectedOption.key, snapModeSettingKey);
    };

    return (
        <div
            className='uiCalProdPlanGridControl'
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px'
            }}
        >
            {renderMenuRow(
                'Display Mode',
                <SarasMenu
                    menuTrigger={renderMenuTrigger('Display Mode', findOptionLabel(DISPLAY_MODE_OPTIONS, activeDisplayMode, activeDisplayMode))}
                    dataList={toMenuData(DISPLAY_MODE_OPTIONS)}
                    menuItem={SarasMenuItem}
                    initialSelectedIndex={displaySelectedIndex >= 0 ? displaySelectedIndex : null}
                    trackSelection={true}
                    onSelection={onDisplayModeSelect}
                />
            )}

            {renderMenuRow(
                'Snap Mode',
                <SarasMenu
                    menuTrigger={renderMenuTrigger('Snap Mode', findOptionLabel(SNAP_MODE_OPTIONS, activeSnapMode, activeSnapMode))}
                    dataList={toMenuData(SNAP_MODE_OPTIONS)}
                    menuItem={SarasMenuItem}
                    initialSelectedIndex={snapSelectedIndex >= 0 ? snapSelectedIndex : null}
                    trackSelection={true}
                    onSelection={onSnapModeSelect}
                />
            )}
        </div>
    );
};

export default ProdPlanGridControl;
